import { render, staticRenderFns } from "./PAF01.vue?vue&type=template&id=1a5302bc&scoped=true&"
import script from "./PAF01.vue?vue&type=script&lang=js&"
export * from "./PAF01.vue?vue&type=script&lang=js&"
import style0 from "./PAF01.vue?vue&type=style&index=0&id=1a5302bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a5302bc",
  null
  
)

export default component.exports